type AddressParts = {
  street?: string;
  street2?: string;
  apartmentLocation?: string;
  postalArea?: string;
};

export default class AddressStringOperations {
  static getNiceAddress({ street, street2, apartmentLocation, postalArea }: AddressParts): string {
    return [street, street2, apartmentLocation, postalArea].filter(part => part).join(', ');
  }
}
